import '../scss/base-px.scss';
import '../scss/main-px.scss';
import $ from 'jquery';
import 'babel-polyfill';
// 兼容低版本ie
import 'es5-shim';
import 'es5-shim/es5-sham';
import { loading } from './loading';
$('.j-video-in source').attr('src', require('../video/entry.mp4'));
$('.j-video-loop source').attr('src', require('../video/loop.mp4'));
loading();
